import React from "react";
import MusicPlatforms from "./MusicPlatforms";
import bandLogo from "../images/LogoCarmenSupermarket.png";

import "../blocks/About.css";

const About = () => {
  return (
    <div className="about" id="about">
      <div className="row">
        <div className="column title-container">
          <h1 className="about-title">
            Conoce a
            <br />
            Carmen
          </h1>
          <img
            className="about-logo"
            src={bandLogo}
            alt="Logotipo de Carmen Supermarket"
            width="220"
            height="220"
            loading="lazy"
          />
        </div>
        <div className="column description-container">
          <p className="about-description">
            Carmen Supermarket es una banda de Pop-Rock de Mallorca que recupera
            la energía guitarrera y el espíritu despreocupado. Su propuesta
            combina riffs potentes, bases rítmicas sólidas y melodías directas
            que transmiten vitalidad.
          </p>
          <p className="about-description">
            La formación está integrada por Willy Julià a la voz y guitarra,
            Miguel Ochogavía al bajo, Miguel González a la batería y Miquel
            Àngel Ribas a los teclados, creando juntos un sonido que mezcla
            frescura y dinamismo en directos explosivos.
          </p>
          {/* <p className="about-description">
            El nombre de la banda es un homenaje a todas las madres que apoyan
            incondicionalmente a sus hijos en sus sueños.
          </p> */}
        </div>
      </div>
      <MusicPlatforms />
    </div>
  );
};

export default About;
